import * as React from 'react';

export const RightArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-1 -1 50 20" {...props}>
    <path
      fill="currentColor"
      d="M41.8467382 11 33.5538449 2.70710678 34.2609517 2 43.8068933 11.5459415 34.2609517 21.0918831 33.5538449 20.3847763 41.9386213 12 1.5 12 1.5 11 41.8467382 11z"
    />
  </svg>
);
